import React from 'react';
import { useDispatch } from 'react-redux';
import { FrontendAction } from '@owl-frontend/api-client/interface';
import { actions as sessionActions } from '../../../data/session/logic';
import { setItem } from '../../../helpers/local-storage';
import { actions as dossiersActions } from '../data/logic';

export const PDF_FIELDS_PREFERENCE_KEY = 'PDF_FIELDS';
export const PDF_FIELDS_PREFERENCE_KEY_DISMISSED = 'PDF_FIELDS_DISMISSED';
export const PDF_FIELDS_PREFERENCE_KEY_INFORMATIONAL =
  'PDF_FIELDS_INFORMATIONAL';
export enum PdfFields {
  Reason = 'reason',
  EventType = 'eventType',
  EventDate = 'eventDate',
  Source = 'source',
  Description = 'description',
  Comments = 'comments',
  Screenshots = 'screenshot',
}
export const DISMISSED_SEPARATOR = '-';
export enum PdfFieldsDismissed {
  Reason = 'reason-dismissed',
  EventType = 'eventType-dismissed',
  EventDate = 'eventDate-dismissed',
  Source = 'source-dismissed',
  Description = 'description-dismissed',
  Comments = 'comments-dismissed',
  Screenshots = 'screenshot-dismissed',
}
export enum PdfFieldsInformational {
  EventType = 'eventType',
  EventDate = 'eventDate',
  Source = 'source',
  Description = 'description',
  Screenshots = 'screenshot',
}

export function useExportDossier(): [
  {
    downloadDossierData(data: {
      dossierId: string;
      fields: string[];
      fieldsDismissed: string[];
      fieldsInformational: string[];
      tabKey: string;
    }): void;
  }
] {
  const dispatch = useDispatch();
  const handler = React.useMemo(
    () => ({
      downloadDossierData: ({
        dossierId,
        fields,
        fieldsDismissed,
        fieldsInformational,
        tabKey,
      }: {
        dossierId: string;
        fields: string[];
        fieldsDismissed: string[];
        fieldsInformational: string[];
        tabKey: string;
      }) => {
        setItem(PDF_FIELDS_PREFERENCE_KEY, fields.join(';'));
        setItem(PDF_FIELDS_PREFERENCE_KEY_DISMISSED, fieldsDismissed.join(';'));
        setItem(
          PDF_FIELDS_PREFERENCE_KEY_INFORMATIONAL,
          fieldsInformational.join(';')
        );

        // todo: include 'closed'
        if (tabKey === 'accepted' || tabKey === 'dismissed') {
          dispatch(
            sessionActions.logEvent({
              events: [
                {
                  action:
                    tabKey === 'accepted'
                      ? FrontendAction.DownloadPdf
                      : FrontendAction.DownloadDismissedPdf,
                  dossierId,
                  pdfFields: [
                    ...fields,
                    ...fieldsDismissed,
                    ...fieldsInformational,
                  ].filter((f) => f.length > 0),
                },
              ],
            })
          );
        }

        dispatch(
          dossiersActions.downloadDossierData({
            dossierId,
            fields,
            fieldsDismissed,
            fieldsInformational,
          })
        );
      },
    }),
    []
  );

  return [handler];
}

export default useExportDossier;
